// Do NOT add "use client" to this file
import { IImage } from "@faire/web-api/indigofair/data/IImage";
import React from "react";

import { TileImage } from "@faire/retailer/features/MarketplaceItems/ProductDetailsTile/TileImage";

interface IProps {
  image: IImage;
  imageAltText: string | undefined;
  showVerticalImagery?: boolean;
  useLazyImageLoading?: boolean;
  imageBreakpoints?: string;
  onLoad: (() => void) | undefined; // This is a client-only prop
}

export const ProductTileImageBase = ({
  image,
  showVerticalImagery,
  imageAltText,
  useLazyImageLoading,
  imageBreakpoints,
  onLoad,
}: IProps) => {
  if (onLoad) {
    return (
      <TileImage
        image={image}
        showVerticalImagery={showVerticalImagery}
        imageAltText={imageAltText}
        useLazyImageLoading={useLazyImageLoading}
        imageBreakpoints={imageBreakpoints}
        onLoad={onLoad}
      />
    );
  }

  return (
    <TileImage
      image={image}
      showVerticalImagery={showVerticalImagery}
      imageAltText={imageAltText}
      useLazyImageLoading={useLazyImageLoading}
      imageBreakpoints={imageBreakpoints}
    />
  );
};
